import { Box, CheckBadge } from '@amzn/ring-ui-react-components';
import { useTranslation } from 'react-i18next';
import { useFeature } from 'src/context/FeatureFlags';
import { useEventCategory } from 'src/shared/context';
import { useEventCardState } from './context';
import { BoxProps } from '../Box';
import { Flex } from '../Flex';
import { Tag } from '../Tag';

export const EventCardTags = (props: BoxProps) => {
  const {
    event: { category, is_resolved },
  } = useEventCardState();
  const { t } = useTranslation('components.event', { useSuspense: false });
  const isVsmFlowEnabled = useFeature('ENABLE_VSM_FLOW');
  const categoryData = useEventCategory(category);

  // Use backend category title if available
  // Otherwise, for publicassistance when VSM flow is enabled, use fallback
  // (This fallback will be removed once backend returns the proper category)
  let title = categoryData?.title;
  if (!title && category === 'publicassistance' && isVsmFlowEnabled) {
    title = t('community-assistance.category-fallback') as string;
  }

  return (
    (title && (
      <Flex data-testid="event-card-tags" {...props}>
        {is_resolved && (
          <Tag bg="positive.100" mr={2}>
            <Flex alignItems="center">
              <CheckBadge color="positive.500" mr={1} boxSize="16px" />
              <Box fontWeight="bold">{t('tag.resolved')}</Box>
            </Flex>
          </Tag>
        )}
        <Tag>{title}</Tag>
      </Flex>
    )) || <></>
  );
};
